export const messageConfig = {
    msg_valid_profile_picture: "Please choose a valid image!", 
    msg_field_is_required : "This field is required!", 
    msg_link_already_exist : "Title already exists!"
}